module.exports = __webpack_public_path__ + "static/media/arrow_left_white.a473338e.svg";